import { APICore } from './apiCore';
const api = new APICore();

const getComment = (update_id) => {
  const baseUrl = `/update/${update_id}/comments`;
  return api.get(`${baseUrl}`);
};

const getCommentById = (params) => {
  const baseUrl = `/update/${params.update_id}/comments/${params.comment_id}`;
  return api.get(`${baseUrl}`);
};

const addComment = (update_id, params) => {
  const baseUrl = `/update/${update_id}/comments`;
  return api.create(`${baseUrl}`, params);
};

const updateComment = (update_id, params) => {
  const baseUrl = `/update/${update_id}/comments/${params.comment_id}`;
  return api.update(`${baseUrl}`, { comment: params.comment });
};

const deleteComment = (params) => {
  const baseUrl = `/update/${params.update_id}/comments/${params.comment_id}`;
  return api.delete(`${baseUrl}`);
};

export { getComment, getCommentById, addComment, updateComment, deleteComment }